import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Sun } from "lucide-react";

interface ISkylightType {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function SkylightType(props: ISkylightType) {
    const { value, onChange, loading } = { ...props };
    const [skylightType, setSkylightType] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setSkylightType(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setSkylightType(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Skylight Type
            </Typography>

            <Select
                placeholder="Select skylight type"
                value={skylightType}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Sun size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="None">None</Option>
                <Option value="Dome Fixed">Dome Fixed</Option>
                <Option value="Flat Fixed">Flat Fixed</Option>
                <Option value="Roof Window">Roof Window</Option>
            </Select>
        </Box>
    );
}
